// Configuração de tema personalizado para o sistema de tickets
// Baseado nas especificações do documento de design

export const theme = {
  // Paleta de cores principal
  colors: {
    // Gradiente de fundo escuro
    background: {
      primary: '#1a1a2e',
      secondary: '#16213e',
      tertiary: '#0f3460'
    },

    // Cores de destaque
    accent: {
      blue: '#4f46e5',
      green: '#10b981',
      red: '#ef4444',
      yellow: '#f59e0b',
      purple: '#8b5cf6'
    },

    // Cores de texto
    text: {
      primary: '#ffffff',
      secondary: '#e5e7eb',
      muted: '#9ca3af',
      dark: '#1f2937'
    },

    // Cores de status
    status: {
      open: '#3b82f6',      // Azul - Aberto
      progress: '#f59e0b',   // Amarelo - Em andamento
      escalated: '#8b5cf6',  // Roxo - Escalado
      resolved: '#10b981',   // Verde - Resolvido
      closed: '#6b7280',      // Cinza - Fechado

      // NOVOS STATUS DUAIS
      waiting_system: '#8b5cf6', // Roxo - Aguardando Sistema
      waiting_user: '#f59e0b',   // Laranja/Amarelo - Aguardando Usuário
      waiting_staff: '#3b82f6'   // Azul - Aguardando Staff
    },

    // Cores por nível de acesso
    access: {
      user: '#3b82f6',       // Azul - Usuário
      support: '#10b981',    // Verde - Suporte
      moderator: '#f59e0b',  // Amarelo - Moderador
      programmer: '#8b5cf6', // Roxo - Programador
      admin: '#ef4444'       // Vermelho - Admin
    }
  },

  // Configurações de tipografia
  typography: {
    fontFamily: {
      primary: 'Inter, system-ui, -apple-system, sans-serif',
      mono: 'JetBrains Mono, Consolas, monospace'
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem'
    }
  },

  // Configurações de espaçamento
  spacing: {
    container: {
      padding: '1rem',
      maxWidth: '1200px'
    },
    card: {
      padding: '1.5rem',
      gap: '1rem'
    }
  },

  // Configurações de bordas e sombras
  effects: {
    borderRadius: {
      sm: '0.375rem',
      md: '0.5rem',
      lg: '0.75rem',
      xl: '1rem'
    },
    shadow: {
      sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
      lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
      xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)'
    }
  },

  // Configurações de animação
  animation: {
    duration: {
      fast: '150ms',
      normal: '300ms',
      slow: '500ms'
    },
    easing: {
      default: 'cubic-bezier(0.4, 0, 0.2, 1)',
      in: 'cubic-bezier(0.4, 0, 1, 1)',
      out: 'cubic-bezier(0, 0, 0.2, 1)',
      inOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
  }
};

// Função para gerar gradiente de fundo
export const getBackgroundGradient = (direction = 'to-br') => {
  return `bg-gradient-${direction} from-[${theme.colors.background.primary}] via-[${theme.colors.background.secondary}] to-[${theme.colors.background.tertiary}]`;
};

// Função para obter cor por status
export const getStatusColor = (status) => {
  const statusMap = {
    'aberto': theme.colors.status.open,
    'em_andamento': theme.colors.status.progress,
    'escalado': theme.colors.status.escalated,
    'resolvido': theme.colors.status.resolved,
    'fechado': theme.colors.status.closed,

    // Novos mapeamentos
    'aguardando_sistema': theme.colors.status.waiting_system,
    'aguardando_usuario': theme.colors.status.waiting_user,
    'aguardando_staff': theme.colors.status.waiting_staff
  };
  return statusMap[status] || theme.colors.status.open;
};

// Função para obter cor por nível de acesso
export const getAccessColor = (level) => {
  const accessMap = {
    'user': theme.colors.access.user,
    'support': theme.colors.access.support,
    'moderator': theme.colors.access.moderator,
    'programmer': theme.colors.access.programmer,
    'admin': theme.colors.access.admin
  };
  return accessMap[level] || theme.colors.access.user;
};
